<template>
  <div class="section ">
    <div
      slot="operations"
      class="triggers"
      style="padding-bottom: 10px"
    >
      <template v-if="action !== 'view'">
        <el-button
          type="primary"
          plain
          @click="cancel"
        >{{ $t('SystemMaintenance.Cancel') }}
        </el-button>
        <el-button
          type="primary"
          @click="toSave"
        >{{ $t('SystemMaintenance.Save') }}
        </el-button>
      </template>
      <template v-else>
        <el-button
          type="primary"
          @click="back"
        >{{ $t('SystemMaintenance.Return') }}
        </el-button>
        <el-button
          type="primary"
          @click="toEdit"
        >{{ $t('SystemMaintenance.Edit') }}
        </el-button>
      </template>
    </div>

    <div style="display: flex">
      <div style="width: 500px">
        <el-form
          :disabled="action === 'view'"
          label-width="100px"
          label-position="left"
        >
          <el-row>
            <el-col :span="16">
              <el-form-item
                :label="$t('SystemMaintenance.BelongingSystem')"
              >
                <el-select v-model="form.systemSource" :disabled="true">
                  <el-option
                    v-for="item in systemSourceList"
                    :key="item.code"
                    :label="item.chineseName"
                    :value="item.code"
                  />
                </el-select>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row>
            <el-col :span="16">
              <!--所属模块-->
              <el-form-item
                :label="$t('SystemMaintenance.BelongsToModule')"
              >
                <el-select v-model="form.module" :disabled="true">
                  <el-option
                    v-for="item in moduleList"
                    :key="item.code"
                    :label="item.chineseName"
                    :value="item.code"
                  />
                </el-select>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row>
            <el-col :span="16">
              <!--所属页面-->
              <el-form-item
                :label="$t('SystemMaintenance.BelongsToPage')"
              >
                <el-select v-model="form.page" :disabled="true">
                  <el-option
                    v-for="item in pageList"
                    :key="item.code"
                    :label="item.chineseName"
                    :value="item.code"
                  />
                </el-select>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row>
            <el-col :span="16">
              <!--广告位-->
              <el-form-item
                :label="$t('SystemMaintenance.AdLocation')"
              >
                <el-select v-model="form.title" :disabled="true">
                  <el-option
                    v-for="item in positionList"
                    :key="item.code"
                    :label="item.chineseName"
                    :value="item.code"
                  />
                </el-select>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row>
            <el-col :span="16">
              <!--状态-->
              <el-form-item
                :label="$t('SystemMaintenance.Status')"
              >
                <el-select v-model="form.status" :disabled="true">
                  <el-option
                    v-for="item in statusList"
                    :key="item.code"
                    :label="item.chineseName"
                    :value="item.code"
                  />
                </el-select>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row>
            <el-col :span="16">
              <!--支持最大广告数-->
              <el-form-item
                :label="$t('SystemMaintenance.MaximumSupportedAdCount')"
              >
                <el-input
                  v-model="form.pushMaxNumber"
                />
              </el-form-item>
            </el-col>
          </el-row>
        </el-form>
      </div>
      <div>
        <img :src="src" style="height: 580px; margin: 0 auto;">
      </div>
    </div>

  </div>
</template>

<script>

import { queryASCForUuidFunc, saveASConfigFunc } from '@/api/sysManage/advertisingConfig'
import CargoAdvanceSelect from '@/components/Cargo/Common/cargoAdvanceSelect'
import { TYPE_NAMES } from '@/utils/class/AdvanceSelect'
import * as SystemConstants from '@/class/cargo/model/parameters/SystemConstants'

export default {
  name: 'AdsDetails',
  components: { CargoAdvanceSelect },
  data() {
    return {
      src: '/static/example_indexTop.png',
      action: 'view',
      selectTypeNames: TYPE_NAMES,
      systemSourceList: SystemConstants.AD_SYSTEM_LIST,
      moduleList: SystemConstants.AD_MODULE_LIST,
      pageList: SystemConstants.AD_PAGE_LIST,
      positionList: SystemConstants.AD_INDEX_LIST,
      statusList: SystemConstants.ADS_STATUS_LIST,
      rowList: [],
      form: {
        uuid: null,
        advertisementNo: null,
        title: 'indexTop',
        page: 'index',
        module: 'index',
        systemSource: 'cargoWare',
        status: '2',
        nowPushNumber: 0,
        pushMaxNumber: 0
      }
    }
  },
  mounted() {

  },
  methods: {
    onShow(data, action, rowList) {
      this.action = action
      this.form = data
      this.src = '/static/example_' + this.form.title + '.png'
      this.rowList = rowList
    },
    toSave() {
      saveASConfigFunc(this.form).then(res => {
        if (res.data) {
          if (this.action === 'add') {
            this.rowList.push(res.data)
          } else if (this.action === 'edit') {
            const index = this.rowList.findIndex(p => p.uuid === res.data.uuid)
            this.rowList[index] = res.data
          }
        }
        this.refreshHandler(this.rowList)
      }).catch((err) => {
        this.$message.error(err)
        this.loading.close()
      })
    },
    refreshHandler(rowList) {
      this.action = 'view'
      this.$emit('refresh', rowList)
    },
    back() {
      this.$emit('back')
    },
    cancel() {
      this.$confirm(this.$t('SystemMaintenance.AreYouWantToCancel'), this.$t('common.tips.prompt'), {
        confirmButtonText: this.$t('common.btn.ok'),
        cancelButtonText: this.$t('common.btn.cancel'),
        type: 'warning'
      }).then(() => {
        if (this.form && this.form.uuid) {
          queryASCForUuidFunc(this.form.uuid).then(res => {
            if (res.data) {
              this.onShow(res.data, 'view', this.rowList)
            }
          }).catch((err) => {
            this.$message.error(err)
            this.loading.close()
          })
        } else {
          this.back()
        }
      })
    },
    toEdit() {
      if (this.form.status !== '3') {
        this.$message.warning(this.$t('SystemMaintenance.CurrentDisabledAndCannotEdited'))
        return
      }
      this.action = 'edit'
    }
  }
}
</script>

<style scoped>

</style>
